import { useCallback } from 'react';

import { useLocalizationContext } from '@order/Localization';
import { useTelemetry } from '@order/Telemetry';

export const useTipTelemetry = () => {
  const { track } = useTelemetry();
  const { formatPrice } = useLocalizationContext();

  const monitorPaymentTipChanged = useCallback(
    (percentage: string, amount: number, subtotal: number) => {
      track('payment_tip.changed', {
        percentage,
        amount: formatPrice(amount, 'USD'),
        subtotal: formatPrice(subtotal, 'USD'),
      });
    },
    [formatPrice, track],
  );

  return {
    monitorPaymentTipChanged,
  };
};
